import { useState, useMemo, useRef, useCallback, useEffect } from "react";
import { Stack, useTheme, Box, Typography } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { RenderTable } from "../../common/splitview-table/RenderTable";
import { gridTheme } from "../../../utils/tableUtils";
import { approverHistoryColumnDefs } from "./column";
import { getApproverHistory } from "../../../api/adminGetApproverHistory";
import Download from "../../../components/common/DownloadGrid/Download";
import { useDispatch } from "react-redux";
import {
  setSelectedDropdownValue,
  setSelectedRow,
} from "../../../redux/actions/supportTicket";

type TableRow = any;
const ApproverHistory = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const gridRef = useRef<any>(null);
  const selectedRowIdsRef = useRef<Set<string>>(new Set());
  const dropdownValuesSetRef = useRef(false);
  const prevPageRef = useRef<number | null>(null);
  const [rows, setRows] = useState<TableRow[]>([]);

  const columnDefs = useMemo(() => [...approverHistoryColumnDefs], []);
  const handleSelectionChanged = useCallback((event: any) => {
    const nodes = event.api.getSelectedNodes();
    selectedRowIdsRef.current = new Set(nodes.map((n: any) => String(n.id)));
    dispatch(setSelectedRow(nodes.map((n: any) => n.data)));

    if (nodes.length > 0 && !dropdownValuesSetRef.current) {
      dropdownValuesSetRef.current = true;
      dispatch(
        setSelectedDropdownValue({
          menuId: "Approver Maintenance",
          categoryId: "Data",
          functionId: "Data",
        }),
      );
    }
    if (nodes.length === 0) {
      dropdownValuesSetRef.current = false;
      dispatch(setSelectedDropdownValue(null));
    }
  }, [dispatch]);

  const handlePageChange = useCallback(
    (e?: any) => {
      const api = gridRef?.current?.api;
      if (!api) return;

      const current = api.paginationGetCurrentPage?.() ?? 0;
      const prev = prevPageRef.current;
      if (prev === null) {
        prevPageRef.current = current;
        return;
      }

      if (current !== prev) {
        api.deselectAll();
        selectedRowIdsRef.current = new Set();
        dropdownValuesSetRef.current = false;
        dispatch(setSelectedRow([]));
        dispatch(setSelectedDropdownValue(null));
        prevPageRef.current = current;
      }
    },
    [dispatch, gridRef],
  );
  const getHistory= async()=>{
    try{
      setLoading(true)
const response = await getApproverHistory()
setRows(response?.map((item, index)=> {
  return({...item, __uid : item.id ?? `${item.materialPlant}__${index}`})
}))
setLoading(false)
    }
    catch(e){
      setRows([])
      setLoading(false)
      console.error("Error fetching approver history:", e);
    }
    
  }
  useEffect(()=>{
getHistory()
  },[])
  return (
    <ThemeProvider theme={theme}>
      <Stack gap={2} padding={2} sx={{ padding: 2, paddingLeft: 0, flex: 1 }}>
        <Stack direction="row"
          gap={ 2 }
          alignItems="center"
          justifyContent="space-between">
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            Approver History
          </Typography>
             <Stack direction="row" spacing={ 1 } alignItems="center">
              <Download loading={loading} gridRef={gridRef} fileName='Approver History' rowData={rows} /></Stack>
        </Stack>
        <RenderTable
          loading={loading}
          gridRef={gridRef}
          columns={columnDefs}
          gridTheme={gridTheme}
          rows={rows}
          rowsPerPage={10}
          setGridReady={() => {}}
          sideBar={{}}
          minimized={null}
          emitEvent={() => {}}
          onChange={() => {}}
          setSelectedRow={() => {}}
          setOpenRejectPopup={() => {}}
          onSelectionChanged={handleSelectionChanged}
          handleChangePage={handlePageChange}
          isSelectedRow={false}
        />

        <Box paddingBottom={1} />
      </Stack>
    </ThemeProvider>
  );
};
export default ApproverHistory;
